import { WarningFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';

export const WarningDialogTemplate = ({ message }) => {
  return (
    <p className="content">
      <WarningFilled className="warning-icon" />
      <span>{message}</span>
    </p>
  );
};

WarningDialogTemplate.propTypes = {
  message: PropTypes.node.isRequired
};
